// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_c5-b";
export var colorBlue = "_c5-8";
export var colorDot = "_c5-0";
export var colorDotLarge = "_c5-2";
export var colorDotSmall = "_c5-1";
export var colorGreen = "_c5-7";
export var colorGrey = "_c5-3";
export var colorOrange = "_c5-5";
export var colorPink = "_c5-a";
export var colorPurple = "_c5-9";
export var colorRed = "_c5-4";
export var colorYellow = "_c5-6";